import { isDate as e } from "./isDate.js";
import { toDate as o } from "./toDate.js";
function a(r) {
  if (!e(r) && typeof r != "number")
    return !1;
  const t = o(r);
  return !isNaN(Number(t));
}
export {
  a as default,
  a as isValid
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/date-fns@3.6.0/~/date-fns/isValid.js
// module id = 210
// module chunks = 67